import { TextLanguage, TranslatedText } from "Store/texts/interfaces";

import { InjuriesFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/riskProductsInterfaces";
import { InsuranceOwnerFormValues } from "Components/Form/CommonFormElements/InsuranceOwnerFormElement/interfaces";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { BaseProduct } from "Store/interfaces/products/checkPrice/BaseProduct";
import { VeteranAutoType } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/VeteranAuto";
import { VeteranAutoCoverage } from "Store/interfaces/products/coverage";
import { TfaAmount } from "../vehicleInterfaces";

export interface VeteranAutoProductIntroFormValues {
  isInGoodCondition: BooleanFormType;
  veteranAutoType: VeteranAutoType;
  firstRegistered: number;
  modelAndValue: string;
  brandOrModel: string;
}

export interface VeteranAutoProductDetailsFormValues
  extends InsuranceOwnerFormValues,
    InjuriesFormValues {}

export interface VeteranAutoProductPriceFormValues extends TfaAmount {
  isMemberOfVeteranClub: BooleanFormType;
  coverage: VeteranAutoCoverage;
}

export interface VeteranAutoPriceRequestInfo extends BaseProduct {
  conditionCheck: boolean;

  brand: VeteranAutoType;
  model: string;
  modelDescription: string;
  registrationYear: string;

  insuranceHolderIsVeteranAutoOwner: boolean;
  veteranAutoOwnerAge?: string;
  isMemberOfVeteranClub: boolean;

  injuries: number;
  injuryYear?: string;

  dateOfBirth?: string;
}

export enum VeteranAutoInsuranceType {
  VETERAN_AUTO_REDUCED_OWN_DAMAGE = "veteranbilDelkasko",
  VETERAN_AUTO_FULL_OWN_DAMAGE = "veteranbilKasko",
}

type VeteranAutoTile = {
  productIntro: {
    ingress: TranslatedText;
  };
  productDetails: {
    heading: TranslatedText;
    ingress: TranslatedText;
  };
  productPrice: {
    heading: TranslatedText;
    ingress: TranslatedText;
    deductibleInfo: {
      title: TranslatedText;
      description: TranslatedText;
    };
  };
};

type VeteranAutoFormTexts = {
  [key: string]: {
    label: TranslatedText;
    hint?: TranslatedText;
    placeholder?: TranslatedText;
    error: Record<string, TranslatedText>;
    options: Record<string, TranslatedText>;
  };
};
export interface VeteranAutoTexts {
  details: {
    [key: string]: Record<TextLanguage, string>;
  };
  formText: { checkPrice: VeteranAutoFormTexts };
  tile: VeteranAutoTile;
  title: TranslatedText;
  name: TranslatedText;
  types: {
    coverageGroup: Record<VeteranAutoCoverage, TranslatedText>;
  };
}
